import React from "react";

function QueryModelIdInput({ value, onChange }) {
  const handleChange = (event) => {
    const inputValue = event.target.value;
    onChange(inputValue);
  };

  return (
    <div className="mb-3">
      <label htmlFor="queryModelIdInput" className="form-label">
        Query Model ID
      </label>
      <input type="text" className="form-control" id="queryModelIdInput" value={value} onChange={handleChange} />
    </div>
  );
}

export default QueryModelIdInput;
